exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.aftersale-detail{padding:30px 0px 0px 10px\n}\n", "", {"version":3,"sources":["/data/jenkins/workspace/shop/src/pages/aftersale/abnormal-detail.vue"],"names":[],"mappings":";AAwEA,kBACE,yBAA0B;CAC3B","file":"abnormal-detail.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.aftersale-detail {\n  padding: 30px 0px 0px 10px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6fc8b694","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/aftersale/abnormal-detail.vue
// module id = Tp79
// module chunks = 2